import { PriceRequestFilterAccommodationType, PriceRequestFilterAccommodationTypes } from '@lx/shared/data-access/types';

type AccommodationType = {
  code: number;
  key: PriceRequestFilterAccommodationType;
  name: string;
};

export const retrieveAccommodationTypes: () => AccommodationType[] = () => {
  const accommodationTypes = {
    [PriceRequestFilterAccommodationTypes.FAMILY_STAY]: $localize`Family stay`,
    [PriceRequestFilterAccommodationTypes.RESIDENCE]: $localize`Residence`,
    [PriceRequestFilterAccommodationTypes.SHARED_APARTMENT]: $localize`Shared apartment`,
    [PriceRequestFilterAccommodationTypes.CAMPUS]: $localize`Campus`,
    [PriceRequestFilterAccommodationTypes.WITHOUT_ACCOMMODATION]: $localize`Without accommodation`,
  };

  return Object.entries(accommodationTypes).map(([key, name], index) => ({
    code: index,
    key: key as PriceRequestFilterAccommodationType,
    name: name,
  }));
};
